<template>
  <transition name="mod-fade">
    <div class="mod-wrapper">
      <div class="mod-backdrop"></div>
      <div class="mod">
        <header class="mod__header">
          <div class="row">
            <div class="col"><h4 class="mod__title">{{ modalTitle }}</h4></div>
            <div class="col-auto">
              <button type="button" class="mod__close-button" @click="close" :title="'Close ' + modalTitle + ' selection'">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg>
              </button>
            </div>
          </div> 
        </header>
        <div class="mod__body" id="modalDescription">

          <div class="row">

            <div class="col-6">
              <div class="mod__text-wrapper">
                <div class="mod__inner-title">Text</div>
                <div class="mod__text">
                  {{ text }}
                </div>
              </div>
            </div>

            <div class="col-6">

              <p class="mod__current-language">
                Current language is
                <select id="tag-lang" v-model="language">
                  <option value="IT">Italian</option>
                  <option value="EN">English</option>
                </select>
              </p>

              <h4 class="mod__inner-title">{{ modalTitle }} list</h4>
              
              <!-- Level 1 -->
              <select class="form-control form-control-sm" id="tag-level1" @change="updateTags($event)" v-model="selectedTagsSchema[0]">
                <option v-for="tag in tagsSchema.level1" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                  <template v-if="language === 'IT'">
                    {{ tag.label }}
                  </template>
                  <template v-else>
                    {{ tag.label_en }}
                  </template>
                </option>
              </select>

              <!-- Level 2 -->
              <template v-if="tagsSchema.level2.length > 0">             
                <select class="form-control form-control-sm" id="tag-level2" @change="updateTags($event)" v-model="selectedTagsSchema[1]">
                  <option v-for="tag in tagsSchema.level2" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                    <template v-if="language === 'IT'">
                      {{ tag.label }}
                    </template>
                    <template v-else>
                      {{ tag.label_en }}
                    </template>
                  </option>
                </select>
              </template>

              <!-- Level 3 -->
              <template v-if="tagsSchema.level3.length > 0">             
                <select class="form-control form-control-sm" id="tag-level3" @change="updateTags($event)" v-model="selectedTagsSchema[2]">
                  <option v-for="tag in tagsSchema.level3" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                    <template v-if="language === 'IT'">
                      {{ tag.label }}
                    </template>
                    <template v-else>
                      {{ tag.label_en }}
                    </template>
                  </option>
                </select>
              </template>

              <!-- Level 4 -->
              <template v-if="tagsSchema.level4.length > 0">             
                <select class="form-control form-control-sm" id="tag-level4" @change="updateTags($event)" v-model="selectedTagsSchema[3]">
                  <option v-for="tag in tagsSchema.level4" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                    <template v-if="language === 'IT'">
                      {{ tag.label }}
                    </template>
                    <template v-else>
                      {{ tag.label_en }}
                    </template>
                  </option>
                </select>
              </template>

              <!-- Level 5 -->
              <template v-if="tagsSchema.level5.length > 0">             
                <select class="form-control form-control-sm" id="tag-level5" @change="updateTags($event)" v-model="selectedTagsSchema[4]">
                  <option v-for="tag in tagsSchema.level5" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                    <template v-if="language === 'IT'">
                      {{ tag.label }}
                    </template>
                    <template v-else>
                      {{ tag.label_en }}
                    </template>
                  </option>
                </select>
              </template>

              <!-- Level 6 -->
              <template v-if="tagsSchema.level6.length > 0">             
                <select class="form-control form-control-sm" id="tag-level6" v-model="selectedTagsSchema[5]">
                  <option v-for="tag in tagsSchema.level6" :key="tag.tax_id || tag.gandtarget_id" :value="tag.tax_id || tag.gandtarget_id">
                    <template v-if="language === 'IT'">
                      {{ tag.label }}
                    </template>
                    <template v-else>
                      {{ tag.label_en }}
                    </template>
                  </option>
                </select>
              </template>

              <h4 class="mod__inner-title mod__inner-title--search mt-5">
                <svg viewBox="-1 0 136 136.21852"><path d="M 93.148438 80.832031 C 109.5 57.742188 104.03125 25.769531 80.941406 9.421875 C 57.851562 -6.925781 25.878906 -1.460938 9.53125 21.632812 C -6.816406 44.722656 -1.351562 76.691406 21.742188 93.039062 C 38.222656 104.707031 60.011719 105.605469 77.394531 95.339844 L 115.164062 132.882812 C 119.242188 137.175781 126.027344 137.347656 130.320312 133.269531 C 134.613281 129.195312 134.785156 122.410156 130.710938 118.117188 C 130.582031 117.980469 130.457031 117.855469 130.320312 117.726562 Z M 51.308594 84.332031 C 33.0625 84.335938 18.269531 69.554688 18.257812 51.308594 C 18.253906 33.0625 33.035156 18.269531 51.285156 18.261719 C 69.507812 18.253906 84.292969 33.011719 84.328125 51.234375 C 84.359375 69.484375 69.585938 84.300781 51.332031 84.332031 C 51.324219 84.332031 51.320312 84.332031 51.308594 84.332031 Z M 51.308594 84.332031" /></svg>
                Search {{ modalTitle }}
              </h4>

              <template v-if="language === 'IT'">
                <v-select label="label" :options="tags" v-model="selectedSearch">
                  <template v-slot:option="tag">
                    {{ tag.label }}
                    <cite>
                      <span v-if="tag.lev_1">{{ labels[tag.lev_1] }}</span>
                      <span v-if="tag.lev_2"> &mdash; {{ labels[tag.lev_2] }}</span>
                      <span v-if="tag.lev_3"> &mdash; {{ labels[tag.lev_3] }}</span>
                      <span v-if="tag.lev_4"> &mdash; {{ labels[tag.lev_4] }}</span>
                      <span v-if="tag.lev_5"> &mdash; {{ labels[tag.lev_5] }}</span>
                      <span v-if="tag.lev_6"> &mdash; {{ labels[tag.lev_6] }}</span>
                    </cite>
                  </template>
                </v-select>
              </template>
              <template v-else>
                <v-select label="label_en" :options="tags" v-model="selectedSearch" /> 
              </template>

            </div> <!-- End .col -->
          </div> <!-- End .row -->

        </div>
        <footer class="mod__footer">
          <button type="button" class="btn btn-primary btn-sm" @click="addTag">Add tag</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
export default {
  name: 'TagsModal',
  props: ['tagValue', 'modalTitle', 'text'],
  components: {
    vSelect,
  },
  data() {
    return {
      tags : [],
      labels: [],
      selectedTags: [],
      tagsSchema : {
        level1 : [],
        level2 : [],
        level3 : [],
        level4 : [],
        level5 : [],
        level6 : []
      },
      selectedTagsSchema : [],
      selectedSearch: null,
      language : 'IT'      
    };
  },    
  computed: {
    ...mapGetters(["errors","isAuthenticated", "taxonomies", "targets"])
  },
  methods: {
    close() {
      this.selectedTagsSchema = [];
      this.selectedSearch = null;
      this.tagsSchema.level2 = [];
      this.tagsSchema.level3 = [];
      this.tagsSchema.level4 = [];
      this.tagsSchema.level5 = [];
      this.$emit('close');
    },
    addTag: function() {
      if(this.selectedSearch){
        this.$emit('childToParent', this.selectedSearch);
      } else {
        let selectedTagId = this.findSelectedTagId();
        for(var i = 0; i < this.tags.length; i++) {
          if(this.tags[i].tax_id === selectedTagId || this.tags[i].gandtarget_id === selectedTagId) {
            this.$emit('childToParent', this.tags[i]);
            break;
          }
        }           
        // this.selectedTagsSchema = [];        
      }
    },
    findSelectedTagId: function(index = null) {
      if(!index) {
        index = this.selectedTagsSchema.length - 1;
      }
      if(this.selectedTagsSchema.length) {
        var result = this.selectedTagsSchema[index];
        if(result === '' || result === undefined) {
          return this.findSelectedTagId(index - 1);
        } else {
          return result;
        }     
      }
    },
    updateTags: function(event) {
      let arrayResult = [];
      var j;
      if(event.target.id === 'tag-level1'){
        for(j = 0; j < this.tags.length; j++) {
            if(this.tags[j].lev_1 === event.target.value 
              && this.tags[j].lev_3 === ''
              && !(this.tags[j].tax_id == event.target.value)
              && !(this.tags[j].gandtarget_id == event.target.value)){
              arrayResult.push(this.tags[j]);
            }             
        }
        this.selectedTagsSchema.length = 1;
        this.tagsSchema.level2 = arrayResult;
        this.tagsSchema.level3 = [];
        this.tagsSchema.level4 = [];
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
        this.selectedSearch = null;
      }
      if(event.target.id === 'tag-level2') {
        for(j = 0; j < this.tags.length; j++) {
            if(this.tags[j].lev_2 === event.target.value 
              && this.tags[j].lev_4 === ''
              && !(this.tags[j].tax_id == event.target.value)
              && !(this.tags[j].gandtarget_id == event.target.value)){
              arrayResult.push(this.tags[j]);
            }             
        }
        this.selectedTagsSchema.length = 2;
        this.tagsSchema.level3 = arrayResult;
        this.tagsSchema.level4 = [];
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
      }
      if(event.target.id === 'tag-level3') {
        for(j = 0; j < this.tags.length; j++) {
            if(this.tags[j].lev_3 === event.target.value 
              && this.tags[j].lev_5 === ''
              && !(this.tags[j].tax_id == event.target.value)
              && !(this.tags[j].gandtarget_id == event.target.value)){
              arrayResult.push(this.tags[j]);
            }             
        }
        this.selectedTagsSchema.length = 3;
        this.tagsSchema.level4 = arrayResult;
        this.tagsSchema.level5 = [];
        this.tagsSchema.level6 = [];
      }
      if(event.target.id === 'tag-level4') {
        for(j = 0; j < this.tags.length; j++) {
            if(this.tags[j].lev_4 === event.target.value 
              && this.tags[j].lev_6 === ''
              && !(this.tags[j].tax_id == event.target.value)
              && !(this.tags[j].gandtarget_id == event.target.value)){
              arrayResult.push(this.tags[j]);
            }             
        }
        this.selectedTagsSchema.length = 4;
        this.tagsSchema.level5 = arrayResult;
        this.tagsSchema.level6 = [];
      }
      if(event.target.id === 'tag-level5') {
        for(j = 0; j < this.tags.length; j++){
            if(this.tags[j].lev_5 === event.target.value 
              && !(this.tags[j].tax_id == event.target.value)
              && !(this.tags[j].gandtarget_id == event.target.value)){
              arrayResult.push(this.tags[j]);
            }             
        }
        this.selectedTagsSchema.length = 5;
        this.tagsSchema.level6 = arrayResult;
      }      
    },
    getTagLabel: function(tax_id) {
      for(var i = 0; i < this.tags.length; i++) {
        if(this.tags[i].tax_id == tax_id) {
          return this.tags[i].label;
        }
      }
    }           
  },
  mounted() {
    if(this.tagValue === 'tax'){
      this.tags = this.taxonomies;
    } else {
      this.tags = this.targets;
    }

    for(var j = 0; j < this.tags.length; j++){
      if(this.tagValue === 'tax') {
        if(this.tags[j].tax_id === this.tags[j].lev_1 ) {
          this.tagsSchema.level1.push(this.tags[j]);
        }        
      } else {
        if(this.tags[j].gandtarget_id === this.tags[j].lev_1 ) {
          this.tagsSchema.level1.push(this.tags[j]);
        }
      }
    }

    let labelsArray = [];
    for(var k = 0; k < this.tags.length; k++) {
      if(this.tagValue === 'tax') {
        labelsArray[this.tags[k].tax_id] = this.tags[k].label;
      } else {
        labelsArray[this.tags[k].gandtarget_id] = this.tags[k].label;
      } 
    }
    this.labels = labelsArray;
  },
  watch: {
    selectedSearch: function(newValue, oldValue){
      if(newValue != oldValue && newValue != null) {
        this.selectedTagsSchema = [];
      }
    }
  }
}  
</script>

<style lang="scss">

.mod-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 95;
}

.mod-backdrop {
  z-index: 96;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
}

.mod {
  max-width: 100%;
  width: rem(1024px);
  padding: rem(20px);
  border-radius: rem(5px);
  background: #fff;
  position: relative;
  z-index: 97;

  &__header {
    margin-bottom: rem(12px);
  }

  &__title {
    font-size: rem(24px);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 0;
  }

  &__close-button {
    border: 0;
    margin: 0;
    background: none;

    &:focus {
      outline: none;
    }

    svg {
      transition: fill .3s ease;
    }

    &:hover svg {
      fill: $color-java;
    }
  }

  &__text-wrapper {
    padding: rem(12px);
    background-color: lighten($color-java, 50%);
    max-height: 500px;
    overflow-y: scroll;
  }

  &__text {
    font-family: $font-family-roboto;
    color: #000;
    font-size: rem(14px);
  }

  &__current-language {
    font-family: $font-family-roboto;
    color: #000;
    font-size: 15px;
    margin-bottom: rem(24px);

    select {
      padding: 0;
      margin: 0;
      border: 0;
      font-family: $font-family-roboto;
      color: #000;
      font-style: italic;
    }
  }

  &__inner-title {
    font-size: rem(16px);
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: rem(8px);
  }

  &__inner-title--search {

    svg {
        display: inline;
        width: rem(14px);
        height: rem(14px);
        fill: $color-genoa;
    }
  }

  .v-select {
    margin-bottom: rem(16px);
  }

  .vs__dropdown-menu {
    max-height: 200px;
  }

  .form-control {
    font-family: $font-family-roboto;
    margin-bottom: rem(8px);
  }

  &__footer {
    text-align: right;
    margin-top: rem(32px);
  }
}

.vs {
  font-family: $font-family-roboto;

  &__dropdown-toggle {
    border-color: $color-java;
    border-radius: rem(8px);
  }

  &__open-indicator {
    fill: $color-genoa;
  }

  &__dropdown-menu,
  &__selected {
    font-family: $font-family-roboto !important;
    font-size: rem(14px);
    font-weight: 700;

    cite {
      display: block;
      width: 100%;
      font-size: rem(10px);
      text-transform: uppercase;
      font-style: normal;
      font-weight: 400;
    }
  }
}

//   .modal-header {
//     border-bottom: 1px solid #eeeeee;
//     color: #4AAE9B;
//     justify-content: space-between;
//   }

//   .modal-footer {
//     border-top: 1px solid #eeeeee;
//     justify-content: flex-end;
//   }

//   .modal-body {
//     position: relative;
//     padding: 20px 10px;
//   }

//   .btn-close {
//     border: none;
//     font-size: 20px;
//     padding: 20px;
//     cursor: pointer;
//     font-weight: bold;
//     color: #4AAE9B;
//     background: transparent;
//   }

//   .btn-green {
//     color: white;
//     background: #4AAE9B;
//     border: 1px solid #4AAE9B;
//     border-radius: 2px;
//   }

//  .modal-fade-enter,
//   .modal-fade-leave-active {
//     opacity: 0;
//   }

//   .modal-fade-enter-active,
//   .modal-fade-leave-active {
//     transition: opacity .5s ease
//   }  
</style>
